import { render, staticRenderFns } from "./containers.vue?vue&type=template&id=776784db"
import script from "./containers.js?vue&type=script&lang=js&external"
export * from "./containers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports